import Email from './email'
import Phone from './phone'
import Name from './name'
import PhoneView from './phone-view'
import LastLoginView from './last-login-view'
import CreatedAtView from './created-at-view'

const Fields = { Email, Phone, Name, PhoneView, LastLoginView, CreatedAtView }

export default Fields
